const state = {
	sourceLanguage: "",
	akkodisResult: {
		value: "",
		enTranslation: "",
		previewValue: ""
	},
	akkodisChallenge: {
		value: "",
		enTranslation: "",
		previewValue: ""
	},
	referenceTitle: {
		value: "",
		enTranslation: "",
		previewValue: ""
	},
	aboutTheClient: {
		value: "",
		enTranslation: "",
		previewValue: ""
	},
	solution: {
		value: "",
		enTranslation: "",
		previewValue: ""
	},
	clientResult: {
		value: "",
		enTranslation: "",
		previewValue: ""
	},
	clientContext: {
		value: "",
		enTranslation: "",
		previewValue: ""
	},
	testimonials: [],
	links: [],
	formInitState: ""
};

const getters = {
	validationTestimonials() {
		return state.testimonials
	},
	validationLinks() {
		return state.links
	},
	validationGetFieldValue: (state) => (fieldName) => {
		return state[fieldName].value;
	},
	validationGetFieldDefaultTranslation: (state) => (fieldName) => {
		return state[fieldName].enTranslation;
	},
	validationGetPreviewValue: (state) => (fieldName) => {
		return state[fieldName].previewValue;
	},
	validationGetFromInitState(state) {
		return state.formInitState;
	},
	validationGetAll(state) {
		return state;
	},
	getSourceLanguage(state) {
		return state.sourceLanguage;
	},
	getValidationData(state) {
		return {
			"akkodisResult": state.akkodisResult.value,
			"aboutTheClient": state.aboutTheClient.value,
			"akkodisChallenge": state.akkodisChallenge.value,
			"solution": state.solution.value,
			"clientResult": state.clientResult.value,
			"referenceTitle": state.referenceTitle.value,
			"clientContext": state.clientContext.value,
			"sourceLang": state.sourceLanguage,
		};
	}
}

const actions = {
	validationSyncStore({commit}, payload) {
		commit('validationSyncStore', payload);
	},
	validationChangeSingleField({commit}, payload) {
		commit("validationChangeSingleField", payload)
	},
	validationSetFormInitState({commit}) {
		commit('validationSetFormInitState');
	},
	validationChangePreviewValue({commit}, payload) {
		commit('validationChangePreviewValue', payload);
	},
	validationFieldChange({commit}, payload) {
		commit('mutationValidationFieldChange', payload);
	}
}

const mutations = {
	validationSyncStore(state, payload) {
		Object.assign(state, payload);
	},
	validationChangeSingleField(state, payload) {
		state[payload.fieldName].value = payload.value;
	},
	validationSetFormInitState(state) {
		state.formInitState = JSON.stringify(state);
	},
	validationChangePreviewValue(state, payload) {
		state[payload.fieldName].previewValue = payload.value;
	},
	mutationValidationFieldChange(state, payload) {
		if (payload.fieldName.includes("_")) {
			let fieldNames = payload.fieldName.split('_');
			if (fieldNames.length === 2) {
				const mainFieldName = fieldNames[0];
				const nestedFieldName = fieldNames[1];
				let foundObject = state[mainFieldName][payload.index];
				foundObject.translations.find(translation => translation.language.name === payload.language)[nestedFieldName] = payload.value;
			}
		} else {
			this.validationChangeSingleField(state, payload);
		}
	}
}

export default {state, getters, actions, mutations};
